import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material';
import { Link } from '@tanstack/react-router';

import { UserStatusChip } from '@/components/common/UserStatusChip';
import { I18N_DE } from '@/i18n/de';
import type { User } from '@/modules/api/backend';

interface UserTableProps {
  userData: User[];
}

export function UserTable({ userData }: UserTableProps) {
  const theme = useTheme();

  return (
    <Table aria-label="User*innen">
      <TableHead>
        <TableRow>
          <TableCell>E-Mail</TableCell>
          <TableCell>Berechtigung</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(userData || []).map((user) => (
          <TableRow
            key={user.id}
            component={Link}
            to={user.id}
            sx={{
              textDecoration: 'none',
              cursor: 'pointer',
              '&:hover': { backgroundColor: theme.palette.action.hover },
              '& .MuiTableCell-root': {
                textDecoration: 'none',
              },
            }}
          >
            <TableCell>{user.email}</TableCell>
            <TableCell>{I18N_DE.UserRole[user.role]}</TableCell>
            <TableCell>
              <UserStatusChip status={user.status} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
